export interface Show {
  id: string;
  name: string;
  logo: string;
}

export const shows: Show[] = [
  { id: 'the-wiz', name: 'The Wiz', logo: '/images/shows/the-wiz.png' },
  { id: 'juliet', name: 'Juliet', logo: '/images/shows/juliet.png' },
  { id: 'annie', name: 'Annie', logo: '/images/shows/annie.png' },
  { id: 'bttf', name: 'Back to the Future', logo: '/images/shows/bttf.png' },
  { id: 'beauty-and-the-beast', name: 'Beauty & the Beast', logo: '/images/shows/beauty-and-the-beast.png' },
  { id: 'beetlejuice', name: 'Beetlejuice', logo: '/images/shows/beetlejuice.png' },
  { id: 'chicago', name: 'Chicago', logo: '/images/shows/chicago.png' },
  { id: 'the-cher-show', name: 'The Cher Show', logo: '/images/shows/the-cher-show.png' },
  { id: 'hamilton', name: 'Hamilton', logo: '/images/shows/hamilton.png' },
  { id: 'lion-king', name: 'The Lion King', logo: '/images/shows/lion-king.png' },
  { id: 'mean-girls', name: 'Mean Girls', logo: '/images/shows/mean-girls.png' },
  { id: 'mj', name: 'MJ The Musical', logo: '/images/shows/mj.png' },
  { id: 'moulin-rouge', name: 'Moulin Rouge', logo: '/images/shows/moulin-rouge.png' },
  { id: 'peter-pan', name: 'Peter Pan', logo: '/images/shows/peter-pan.png' },
  { id: 'tina', name: 'Tina', logo: '/images/shows/tina.png' },
  { id: 'wicked', name: 'Wicked', logo: '/images/shows/wicked.png' },
];
